<template>
<div class="container py-5">
  <h1>Política de Privacidad</h1>
  <p>Última actualización: 28 de abril de 2025</p>

  <h2>Información que recopilamos</h2>
  <p>En <strong>Medicynia</strong> recopilamos información personal que usted nos proporciona directamente al registrarse o utilizar el servicio, como: nombre completo, correo electrónico, número de teléfono, cédula profesional, especialidad médica, datos de pacientes (nombre, género, fecha de nacimiento, contacto, información médica) y datos de navegación anónimos para mejorar nuestro servicio.</p>

  <h2>Cómo usamos tu información</h2>
  <p>Utilizamos la información recopilada para: crear y administrar cuentas de usuario, prestar el servicio de expediente clínico, facilitar la comunicación entre médicos y pacientes, generar documentos clínicos conforme a la normatividad vigente, realizar análisis internos para mejorar nuestro servicio, y cumplir obligaciones legales.</p>

  <h2>Cómo compartimos tu información</h2>
  <p><strong>Medicynia</strong> no comparte, vende ni alquila su información personal a terceros para fines comerciales. Solo compartiremos su información si: (i) es requerido por autoridades competentes conforme a la ley, (ii) es necesario para proteger nuestros derechos legales, o (iii) el usuario autoriza expresamente su transferencia a un tercero (por ejemplo, para interoperabilidad con sistemas hospitalarios).</p>

  <h2>Seguridad de tu información</h2>
  <p>Implementamos medidas técnicas y administrativas razonables para proteger su información, incluyendo: cifrado de datos en tránsito y en reposo, control de acceso seguro, copias de seguridad periódicas, monitoreo de servidores, y procedimientos internos de confidencialidad. Sin embargo, ningún sistema puede garantizar seguridad absoluta.</p>

  <h2>Tus derechos</h2>
  <p>De acuerdo con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, usted tiene derecho a acceder, rectificar, cancelar u oponerse (Derechos ARCO) al tratamiento de sus datos personales. Puede ejercer estos derechos enviándonos una solicitud a nuestro correo electrónico de contacto.</p>

  <h2>Cambios a esta política</h2>
  <p>Nos reservamos el derecho de actualizar esta Política de Privacidad en cualquier momento. Le notificaremos cualquier cambio importante mediante publicación en nuestro sitio web o por medios de contacto registrados. Le recomendamos revisar periódicamente esta política.</p>

  <h2>Contacto</h2>
  <p>Para ejercer sus derechos ARCO o resolver dudas relacionadas con el tratamiento de su información personal, puede contactarnos en: <strong>contacto@medicynia.com</strong></p>
</div>

</template>

<script>
import { useHead } from '@vueuse/head'

export default {
  name: 'PrivacyPolicyView',
  setup() {
    useHead({
      title: 'Política de Privacidad | Medicynia',
      meta: [
        { name: 'description', content: 'Lee la política de privacidad de Medicynia. Descubre cómo protegemos y tratamos tus datos personales conforme a la ley mexicana.' },
        { property: 'og:title', content: 'Política de Privacidad | Medicynia' },
        { property: 'og:description', content: 'Lee la política de privacidad de Medicynia. Descubre cómo protegemos y tratamos tus datos personales conforme a la ley mexicana.' },
        { property: 'og:type', content: 'article' },
        { property: 'og:url', content: 'https://medicynia.com/privacy-policy' },
        { property: 'og:image', content: 'https://medicynia.com/logo-main.webp' },
        { name: 'robots', content: 'index, follow' }
      ],
      link: [
        { rel: 'canonical', href: 'https://medicynia.com/privacy-policy' }
      ]
    })
  }
}
</script>

<style scoped>
/* Add styles if needed */
h1 {
  margin-bottom: 1rem;
}
h2 {
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
}
p {
  line-height: 1.6;
}
</style>